import React from 'react';

interface SecondaryButtonProps {
  text: string;
  onClick: () => void;
  disable?: boolean;
}

const SecondaryButton: React.FC<SecondaryButtonProps> = ({ text, onClick, disable }) => {
  return (
    <button
      onClick={onClick}
      className={`bg-btSecondary w-full rounded-lg border-0 py-4 text-base font-semibold leading-5`}
    >
      <span className={`text-btText ${disable ? 'opacity-30' : ''}`}>{text}</span>
    </button>
  );
};

export default SecondaryButton;
